import styled from "@emotion/styled"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Container, Typography } from "@mui/material"

export const Section = styled(SectionWrapper)`
  padding-top: ${({ theme }) => theme.typography.pxToRem(120)};
`

export const Wrapper = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.dark};
  text-align: center;
  font-size: ${({ theme }) => theme.typography.pxToRem(52)};
  font-style: normal;
  font-weight: 500;
  line-height: ${({ theme }) => theme.typography.pxToRem(64)};
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(40)};
  letter-spacing: -0.52px;

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(36)};
    line-height: ${({ theme }) => theme.typography.pxToRem(44)};
    letter-spacing: normal;
  }
`

export const Description = styled.div`
  max-width: 753px;
  p,
  strong {
    color: ${({ theme }) => theme.palette.primary.main};
    text-align: center;
    font-size: ${({ theme }) => theme.typography.pxToRem(19)};
    font-style: normal;
    font-weight: 400;
    line-height: ${({ theme }) => theme.typography.pxToRem(30)};
    opacity: 0.8;
  }
  strong {
    color: ${({ theme }) => theme.palette.tertiary.dark};
    font-weight: 500;
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    p,
    strong {
      font-size: ${({ theme }) => theme.typography.pxToRem(17)};
      line-height: ${({ theme }) => theme.typography.pxToRem(28)};
    }
  }
`
